import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  HContainer,
  Spinner,
  Text,
  VContainerH,
  VContainerVH
} from '@vodacom/web-common';

import {
  CustomColors
} from '../../../constants';

import {
  withScreenViewTagging
} from 'hocs';

import {
  formatCurrency,
  getStorageWithExpiry
} from 'helpers';

import {
  PrimaryButton,
  SecondaryButton
} from 'components';

const Card = styled(VContainerH)`
  z-index: 5;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const ConfirmPurchaseUI = props => {

  const offer = props.offer;

  ConfirmPurchaseUI.tagViewData = {
    journey_event: 'journey_start',
    journey_step: 'cbu: connectu: just 4 you: purchase summary',
    journey_name: 'cbu: connectu: just 4 you',
    journey_type: 'just for you',
    sales_event:  'product_view',
    product_id: [ offer?.description ],
    product_category: 'just 4 you',
    product_quantity: '1',
    product_price: offer?.price,
    page_section: 'just 4 you',
    visitor_type: 'consumer',
    visitor_customer_segment: getStorageWithExpiry('msisdn', 'msisdnType', ''),
    visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', '')
  };

  return (

    <Card
      backgroundColor={CustomColors.White}
      borderRadius={'4px'}
      padding={'16px 55px 26px'}
      maxWidth={'350px'}
      boxSizing={'border-box'}
      width={'92%'}>

      <VContainerVH>

        {props.isLoading ?

          <Spinner
            color={CustomColors.Red1}
            size='150'/>

        : <>
            <Text
              fontSize={'16px'}
              fontWeight={'bold'}
              color={CustomColors.Grey11}
              textAlign={'center'}
              padding={'0 0 16px'}>
              {'Confirm purchase'}

            </Text>

            <Text
              fontSize={'14px'}
              color={CustomColors.Grey9}
              textAlign={'center'}
              padding={'0 30px 16px'}>
              {`${offer?.description} at ${formatCurrency(offer?.price)}, to be deducted from your Airtime.`}

            </Text>

            <HContainer>

              <SecondaryButton
                width={'90px'}
                minWidth={'90px'}
                margin={'0 16px 0 0'}
                text={'Close'}
                onClick={props.onClose}/>

              <PrimaryButton
                width={'90px'}
                minWidth={'90px'}
                text={'Confirm'}
                onClick={props.onConfirm}/>
            </HContainer>
          </>
        }
      </VContainerVH>
    </Card>
  );
};

ConfirmPurchaseUI.propTypes = {
  offer: PropTypes.object
};

ConfirmPurchaseUI.defaultProps = {
  offer: {}
};

ConfirmPurchaseUI.pageName = 'cbu: connectu: just 4 you: purchase summary';

export const ConfirmPurchase = withScreenViewTagging(ConfirmPurchaseUI);